export default {
	errors: {
		server: "Error interno del servidor. Intente nuevamente más tarde.",
		connection: "Error de conexión con el servidor. Verifique su conexión a internet.",
		retry: "Intentar de nuevo",
		timeout: "Tiempo de conexión agotado. Verifique su conexión a internet.",
		tooManyRequests: "Demasiadas solicitudes en poco tiempo. Espere un momento.",
	},
};
